export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10187.90fed3d4.jpg";